import { Action, initialState, State } from 'store/store';

export const updateInteractionsSeen = (
  state: State = initialState,
  { data }: Action
): State => {
  // return state;

  // console.log(data);

  let { interactionsSeen = [] } = state as any;

  // interactionsSeen = interactionsSeen.filter(i => {
  //   return typeof i === 'string';
  // });

  //

  if (Array.isArray(data)) {
    const newInteractionsSeen = data.length
      ? Array.from(new Set([...interactionsSeen, ...data]))
      : [];

    // console.log({ newInteractionsSeen });

    return {
      ...state,
      // interactionsSeen: [
      //   ...Array.from(new Set([...interactionsSeen, ...data])),
      // ],
      interactionsSeen: newInteractionsSeen,
    } as any;
  }

  if (interactionsSeen.includes(data.id)) {
    return state;
  } else {
    return {
      ...state,
      interactionsSeen: [...interactionsSeen, data.id],
    } as any;
  }
};
